/**
 * Shop the Look - Products Slider
 * Initializes Swiper for mobile product grid
 */

if (!customElements.get('shop-the-look-products')) {
    class ShopTheLookProducts extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init() {
            const swiperElement = this.querySelector('.shop-the-look__products-swiper');

            if (!swiperElement) return;

            // Initialize Swiper only for mobile
            const initSwiper = () => {
                if (window.innerWidth < 750) {
                    if (!this.swiper) {
                        this.swiper = new Swiper(swiperElement, {
                            slidesPerView: 1.6,
                            spaceBetween: 16,
                            pagination: {
                                el: '.shop-the-look__pagination',
                                clickable: true,
                            },
                            breakpoints: {
                                0: {
                                    slidesPerView: 1.6,
                                    spaceBetween: 16,
                                }
                            }
                        });
                    }
                } else {
                    // Destroy swiper on desktop
                    if (this.swiper) {
                        this.swiper.destroy(true, true);
                        this.swiper = null;
                    }
                }
            };

            // Initialize on load
            initSwiper();

            // Re-initialize on resize
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    initSwiper();
                }, 250);
            });
        }
    }

    customElements.define('shop-the-look-products', ShopTheLookProducts);
}
